import moment from 'moment'

const AUTHORIZATION_EXPIRATION_ROW_CSS = {
  backgroundColor: '#f8d7da !important',
  '&:hover': {
    backgroundColor: '#f8d7da !important',
  },
}

export const getAuthorizationExpirationRowCss = (row: {
  authorizationValidTo?: string | null
}): Record<string, string | Record<string, string>> | undefined => {
  if (!row.authorizationValidTo) {
    return undefined
  }

  const expirationDate = moment(row.authorizationValidTo).startOf('day')

  if (!expirationDate.isValid()) {
    return undefined
  }

  const daysUntilExpiration = expirationDate.diff(moment().startOf('day'), 'days')

  if (daysUntilExpiration > 10) {
    return undefined
  }

  return AUTHORIZATION_EXPIRATION_ROW_CSS
}
